import React from "react";

import { GetStaticProps } from "next";
import {
  CTypeBeneficiaryHead,
  BTypeCardView,
  RichSearch,
  nationalMeritFaqRichSearch,
  ATypeNationalMeritHead,
  ATypeNationalMeritSummary,
  FullWidthTwinButton,
  call,
  GOI_WEB_URL,
  customEvent,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import parlors from "goi_common/src/constants/parlors_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos, bestParlorIds } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const regionBestParlors = parlors.filter((p) => bestParlorIds.includes(p.id));
  const description =
    "부산울산경남 국가유공자 장례 시 다음의 혜택을 받을 수 있습니다. 1) 지역 내 모든 화장 시설 비용이 무료입니다. 2) 장례식장 별로 혜택이 제공됩니다.  3) 지역 내 모든 공설 장지에 우선 안치됩니다. 4) 국립현충원 및 호국원에 안장 가능합니다.";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      regionBestParlors,
      pageDescription: description,
      pageKeywords: `국가유공자 장례, 부산 국가유공자 장례, 울산 국가유공자 장례, 경남 국가유공자 장례, 부산울산경남 국가유공자 장례, 부산울산경남 국가유공자 장례 준비, 부산울산경남 국가유공자 장례 비용`,
      pageOgTitle: `국가유공자장례 114 안내 정보 포털 ::  부산울산경남장례정보포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  regionBestParlors,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  regionBestParlors: Array<any>;
  pageOgTitle: string;
}) {
  const faqList = nationalMeritFaqRichSearch;
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        <RichSearch data={faqList} />
      </Head>
      <Stack style={{ backgroundColor: regionColor.c100 }} padding="40px 0">
        <ATypeNationalMeritHead
          titleSido="부산 울산 경남"
          title="국가유공자 장례114"
          mainColor={regionColor}
          isAlignCenter
        />
      </Stack>
      <Stack
        margin="20px 12px"
        padding="16px 16px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <ATypeNationalMeritSummary mainColor={regionColor} />
        <Box className="subtitle_14_b" textAlign="center">
          상담을 통해 자세한 국가 유공자 장례 혜택을 안내드립니다.
        </Box>
        <FullWidthTwinButton
          firstBtn={{
            isGoiCall: true,
            text: "상담하기",
            onClick: () => {
              call("1666-9784");
              customEvent({
                domain: "gyeongsang",
                path: "nat",
                trigger_and_target: "goi_call",
              });
            },
          }}
          secondBtn={{
            text: "비용 알아보기",
            href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
            onClick: () => {
              customEvent({
                domain: "gyeongsang",
                path: "nat",
                trigger_and_target: "uv_mth_req",
              });
            },
          }}
          backgroundColor={regionColor.c400}
        />
      </Stack>

      <Stack
        margin="20px 12px"
        padding="24px 16px 10px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <h3 className="subtitle_18_b">부산 울산 경남 장례식장</h3>
        {regionBestParlors.map((res) => (
          <BTypeCardView
            key={res.companyname}
            name={res.companyname}
            mainColor={regionColor}
            href={`https://www.goifuneral.co.kr/match/parlor-request/${res.companyname}/`}
            descriptions={[
              `빈소 평균 비용 : ${Number(
                res.binso_average_charge
              ).toLocaleString()}원`,
            ]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            arrowText="혜택 알아보기"
            event={{
              domain: "gyeongsang",
              path: "nat",
              trigger_and_target: "uv_prlr_detail",
            }}
          />
        ))}
      </Stack>

      <Stack
        margin="20px 12px"
        padding="24px 16px 10px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <h3 className="subtitle_18_b">부산 울산 경남 국가유공자 무료 화장장</h3>
        {regionCrematoriums.map((res) => (
          <BTypeCardView
            descriptions={["국가유공자 무료"]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/national/free-crema/${res.companyname} 소개/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gyeongsang",
              path: "nat",
              trigger_and_target: "uv_fr_crema_detail",
            }}
          />
        ))}
      </Stack>

      <Stack
        margin="20px 12px"
        padding="24px 16px 10px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <h3 className="subtitle_18_b">
          부산 울산 경남 국가유공자 무료 장지 (공설)
        </h3>
        {regionPublicFacilities.map((res) => (
          <BTypeCardView
            descriptions={["국가유공자 우선 안치"]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/national/free-facility/${res.companyname} 소개/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gyeongsang",
              path: "nat",
              trigger_and_target: "uv_fr_facility_detail",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
